import React from "react"
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import { AppState } from "../../AppState"
import { GetSelectedAssignedClinic, GetSelectedPortal } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import { Home } from "../../config/Routes"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import { EditLocationInformation } from "./EditLocationInformation"

interface LocationInformationProps extends RouteComponentProps { }

interface LocationInformationAuthProps {
  portalID: number
  companyID: number
  locationID: number
}

export class LocationInformation extends React.PureComponent<LocationInformationProps & LocationInformationAuthProps> {
  handleCancel = () => this.props.history.push(Home)

  render() {
    const { portalID, companyID, locationID } = this.props
    return <AppPageWrapper showNav>
      <EditLocationInformation adminMode={false} portalID={portalID} companyID={companyID} locationID={locationID} onCancel={this.handleCancel} />
    </AppPageWrapper>
  }
} 

function mapStateToProps(state: AppState): LocationInformationAuthProps {
  const selectedCompany =  GetSelectedAssignedClinic(state)
  return {
    portalID: GetSelectedPortal(state)?.ImplementationID || 0,
    companyID: selectedCompany?.AccountID || 0,
    locationID: selectedCompany?.LocationID || 0
  }
}
export default connect(mapStateToProps)(LocationInformation)
